module.exports = __webpack_public_path__ + "static/media/Heebo-Bold.f0f23580.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avesco/Heebo-Bold.woff
// module id = 784
// module chunks = 0